import { useEffect } from 'react'
/**
 * Sets the marketing consent cookie to opt-out when Global Privacy Control is enabled.
 * Polls for utag availability since it may not be ready on initial load.
 *
 * @param {boolean} gpcFeatureEnabled Whether the GPC feature is enabled
 */
export default function useGlobalPrivacyControl (gpcFeatureEnabled = false) {
  useEffect(() => {
    if (!gpcFeatureEnabled || !navigator.globalPrivacyControl) {
      return
    }

    /**
     * c3 is the marketing consent cookie
     * 0 is the opt-out value
     */
    const turnOffMarketingCookie = () => {
      const setCookieValue = window?.utag?.gdpr?.setCookieValue
      if (typeof setCookieValue === 'function') {
        setCookieValue('c3', '0')
        return true
      }
      return false
    }

    // Try immediately first
    if (turnOffMarketingCookie()) return

    /**
     * Due to setCookieValue not being available immediately,
     * fallback to interval
     */
    const intervalId = setInterval(() => {
      if (turnOffMarketingCookie()) clearInterval(intervalId)
    }, 1000)

    return () => clearInterval(intervalId)
  }, [gpcFeatureEnabled])
}
